declare global {
  interface Window {
    adconsent: (
      arg0: string,
      arg1?: any,
      arg2?: (consent: any, success: any) => any
    ) => void;
    __tcfapi: (
      arg0: string,
      arg1: number,
      arg2: (tcData: any, success: any) => void
    ) => void;
    snigelPubConf: {
      adengine: {
        activeAdUnits: string[];
      };
    };
    dataLayer?: any[];
    gtag?: any;
  }
}

/**
 * Loads ad script and sets active ad units.
 * For Premium users ad script needs to be loaded so we can get consent, but active units should be empty so no ads appear.
 * For non premium users, ad script needs to be loaded with correct active ad units.
 */
export function loadAdScript(isPremium: boolean) {
  // set active ad units
  setActiveAdUnits(isPremium);

  // load ad script
  const href = window.location.href;
  let src = "";
  if (href.includes("staging") || href.includes("localhost")) {
    console.log("Loading STAGING ads script");
    src =
      "https://staging-cdn.snigelweb.com/adengine/emovi.teuteuf.fr/loader.js";
  } else {
    console.log("Loading LIVE ads script");
    src = "https://cdn.snigelweb.com/adengine/emovi.teuteuf.fr/loader.js";
  }

  let node = document.createElement("script");
  node.src = src;
  node.type = "text/javascript";
  node.async = true;
  node.setAttribute("data-cfasync", "false");
  document.getElementsByTagName("head")[0].appendChild(node);
}

function getActiveAdUnits(): string[] {
  let breakpoint = "small";

  const w = window.innerWidth;

  breakpoint = w >= 1000 ? "large" : breakpoint;
  breakpoint = w >= 1920 ? "xlarge" : breakpoint;

  let activeUnits: string[] = [];

  switch (breakpoint.toLowerCase()) {
    case "small":
      activeUnits = ["top_banner", "adhesion"];
      break;
    case "large":
      activeUnits = ["top_banner", "adhesion", "sidebar_left"];
      break;
    case "xlarge":
      activeUnits = [
        "top_banner",
        "adhesion",
        "sidebar_left",
        "sidebar_bottom",
      ];
      break;
  }

  window.snigelPubConf = {
    adengine: {
      activeAdUnits: activeUnits,
    },
  };
  return activeUnits;
}

function setActiveAdUnits(isPremium: boolean): void {
  if (isPremium) {
    window.snigelPubConf = {
      adengine: {
        activeAdUnits: [""],
      },
    };
    return;
  }

  const activeUnits = getActiveAdUnits();

  window.snigelPubConf = {
    adengine: {
      activeAdUnits: activeUnits,
    },
  };
}

/**
 * Check for consent through Snigel, then set GA consent
 */
export const checkForConsent = () => {
  window.addEventListener("adnginLoaderReady", function () {
    window.adconsent &&
      window.adconsent("getConsent", null, function (consent, success) {
        if (success) {
          if (consent.fullConsent) {
            console.log("########### yas consent");
            window.gtag("consent", "update", {
              ad_storage: "granted",
              analytics_storage: "granted",
              ad_user_data: "granted",
              ad_personalization: "granted",
            });
          } else {
            console.log("########### naur consent");
            clearAnalyticsCookies();
          }
        }
      });
  });
};

export function clearAnalyticsCookies(): void {
  const teuteufCookieNames = ["_gid"];

  // delete all _ga cookies
  document.cookie
    .split(";")
    .map((c) => c.trim())
    .forEach((cookie) => {
      const name = cookie.split("=")[0];
      if (name.startsWith("_ga")) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.teuteuf.fr`;
      }
    });

  // delete other analytics cookies
  teuteufCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.teuteuf.fr`;
  });
}